import { createAction, props } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';

export const FETCH_SCORINGSYSTEMS_REQUEST =
    '[Scoring System] Fetch system request';
export const FETCH_SCORINGSYSTEMS_SUCCESS =
    '[Scoring System] Fetch system success';
export const FETCH_SCORINGSYSTEMS_FAILURE =
    '[Scoring System] Fetch system failure';

export const UPDATE_SCORINGSYSTEM_REQUEST =
    '[Scoring System] Update system request';
export const UPDATE_SCORINGSYSTEM_SUCCESS =
    '[Scoring System] Update system success';
export const UPDATE_SCORINGSYSTEM_FAILURE =
    '[Scoring System] Update system failure';

export const FETCH_SCORINGGAMEPLATFORM_REQUEST =
    '[Scoring Game Platform] Fetch Scoring game platform request';
export const FETCH_SCORINGGAMEPLATFORM_SUCCESS =
    '[Scoring Game Platform] Fetch Scoring game platform success';
export const FETCH_SCORINGGAMEPLATFORM_FAILURE =
    '[Scoring Game Platform] Fetch Scoring game platform failure';

export const UPDATE_SCORINGGAMEPLATFORM_REQUEST =
    '[Scoring Game Platform] Update Scoring game platform request';
export const UPDATE_SCORINGGAMEPLATFORM_SUCCESS =
    '[Scoring Game Platform] Update Scoring game platform success';
export const UPDATE_SCORINGGAMEPLATFORM_FAILURE =
    '[Scoring Game Platform] Update Scoring game platform failure';

export const fetchScoringSystemsRequests = createAction(
    FETCH_SCORINGSYSTEMS_REQUEST
    // props<{ payload: any }>()
);
export const fetchScoringSystemsSuccess = createAction(
    FETCH_SCORINGSYSTEMS_SUCCESS,
    props<{ payload: any }>()
);
export const fetchScoringSystemFailure = createAction(
    FETCH_SCORINGSYSTEMS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const updateScoringSystemRequests = createAction(
    UPDATE_SCORINGSYSTEM_REQUEST,
    props<{ body: any }>()
);
export const updateScoringSystemSuccess = createAction(
    UPDATE_SCORINGSYSTEM_SUCCESS,
    props<{ body: any }>()
);
export const updateScoringSystemFailure = createAction(
    UPDATE_SCORINGSYSTEM_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const fetchScoringGamePlatformRequests = createAction(
    FETCH_SCORINGGAMEPLATFORM_REQUEST,
    props<{ gameid: string }>()
);
export const fetchScoringGamePlatformSuccess = createAction(
    FETCH_SCORINGGAMEPLATFORM_SUCCESS,
    props<{ payload: any }>()
);
export const fetchScoringGamePlatformFailure = createAction(
    FETCH_SCORINGGAMEPLATFORM_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const updateScoringGamePlatformRequests = createAction(
    UPDATE_SCORINGGAMEPLATFORM_REQUEST,
    props<{ gameid: string; body: any }>()
);
export const updateScoringGamePlatformSuccess = createAction(
    UPDATE_SCORINGGAMEPLATFORM_SUCCESS,
    props<{ body: any }>()
);
export const updateScoringGamePlatformFailure = createAction(
    UPDATE_SCORINGGAMEPLATFORM_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
